import Map from 'ol/Map.js';
import OSM from 'ol/source/OSM.js';
import TileLayer from 'ol/layer/Tile.js';
import View from 'ol/View.js';
import {Control, defaults as defaultControls} from 'ol/control.js';

class bCapaActiva extends Control {
    /**
   * @param {Object} [opt_options] Control options.
   */
    constructor(opt_options) {
        const options = opt_options || {};
    
        const button = document.createElement('button');
        button.innerText = 'Capas Activas';
    
        const element = document.createElement('div');
        element.className = 'boton-capas-activas ol-unselectable ol-control';
        element.appendChild(button);
    
        super({
          element: element,
          target: options.target,
        });

        //logica
        const capasActivas = document.getElementById('capas-activas');
        const buttonInside=document.createElement('button')
        buttonInside.innerText='Capas Activas'

        capasActivas.appendChild(buttonInside)

        const contenedorCapasActivas=document.createElement('div')
        contenedorCapasActivas.className='contenedor-capas-activas'
        capasActivas.appendChild(contenedorCapasActivas)

        let isActive = false;
        
    
        button.addEventListener('click', ()=>{
            isActive = !isActive; 
            if (isActive) {
                capasActivas.style.display = 'block';
                button.style.display='none'
            } else {
                capasActivas.style.display = 'none'; 
                button.style.display = 'block';
            }
        });

        buttonInside.addEventListener('click',(event)=>{
            event.stopPropagation();

            capasActivas.style.display = 'none'; 
            isActive = false; 
            button.style.display = 'block'; 
        })

      }
    
}
    

export default bCapaActiva